import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="w-full bg-gray-900 text-gray-400 py-8" data-id="element-52">
        <div className="max-w-6xl mx-auto px-6 text-center" data-id="element-53">
          <p className="text-sm" data-id="element-54">
            © {new Date().getFullYear()} Menopausia Sin Niebla. Todos los
            derechos reservados.
          </p>
          <p className="text-xs mt-2 mb-4" data-id="element-55">
            Este producto es solo para fines educativos y no sustituye el
            consejo médico profesional.
          </p>
          <div className="flex items-center justify-center gap-4 text-sm" data-id="element-56">
            <button onClick={() => setActiveModal('privacy')} className="text-gray-400 hover:text-white transition-colors underline underline-offset-2 cursor-pointer" data-id="element-57">
              Política de Privacidad
            </button>
            <span className="text-gray-600" data-id="element-58">•</span>
            <button onClick={() => setActiveModal('terms')} className="text-gray-400 hover:text-white transition-colors underline underline-offset-2 cursor-pointer" data-id="element-59">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-60">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-61">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.25
        }} className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-62">
              <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200" data-id="element-63">
                <h3 className="text-xl font-bold text-teal-900" data-id="element-64">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 hover:bg-gray-100 rounded-full transition-colors cursor-pointer" aria-label="Cerrar" data-id="element-65">
                  <XIcon className="w-5 h-5 text-gray-600" data-id="element-66" />
                </button>
              </div>

              <div className="px-6 py-6 overflow-y-auto max-h-[calc(80vh-72px)] text-gray-700 text-sm leading-relaxed space-y-4" data-id="element-67">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-68" /> : <TermsContent data-id="element-69" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-xs text-gray-500" data-id="element-70">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="text-lg font-semibold text-teal-900 mt-4" data-id="element-71">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-72">
        Recopilamos información personal que usted nos proporciona
        voluntariamente al realizar una compra, incluyendo: nombre, dirección de
        correo electrónico y datos de pago. Los datos de pago son procesados de
        forma segura por nuestro proveedor de pagos y no almacenamos información
        de tarjetas de crédito en nuestros servidores.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-73">
        2. Uso de la Información
      </h4>
      <p data-id="element-74">Utilizamos su información personal exclusivamente para:</p>
      <ul className="list-disc pl-6 space-y-1" data-id="element-75">
        <li data-id="element-76">Procesar y entregar su compra.</li>
        <li data-id="element-77">Enviar actualizaciones relacionadas con el producto adquirido.</li>
        <li data-id="element-78">Responder a sus consultas o solicitudes de soporte.</li>
      </ul>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-79">
        3. Protección de Datos
      </h4>
      <p data-id="element-80">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger su información personal contra acceso no autorizado,
        alteración, divulgación o destrucción.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-81">
        4. Compartir Información
      </h4>
      <p data-id="element-82">
        No vendemos, intercambiamos ni transferimos su información personal a
        terceros, excepto a proveedores de servicios de confianza que nos
        asisten en la operación de nuestro sitio web y el procesamiento de
        pagos, siempre que dichas partes acuerden mantener esta información
        confidencial.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-83">5. Cookies</h4>
      <p data-id="element-84">
        Nuestro sitio puede utilizar cookies para mejorar la experiencia del
        usuario. Usted puede configurar su navegador para rechazar cookies,
        aunque esto podría afectar la funcionalidad del sitio.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-85">6. Sus Derechos</h4>
      <p data-id="element-86">
        Usted tiene derecho a acceder, rectificar o eliminar su información
        personal en cualquier momento. Para ejercer estos derechos, puede
        comunicarse con nosotros a través de los canales indicados en nuestro
        sitio.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-87">
        7. Cambios a Esta Política
      </h4>
      <p data-id="element-88">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-xs text-gray-500" data-id="element-89">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="text-lg font-semibold text-teal-900 mt-4" data-id="element-90">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-91">
        Al acceder y utilizar este sitio web y adquirir el producto "Menopausia
        Sin Niebla: El Protocolo de 21 Días", usted acepta estar sujeta a estos
        términos y condiciones. Si no está de acuerdo con alguno de estos
        términos, le rogamos que no utilice nuestro sitio ni adquiera nuestros
        productos.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-92">
        2. Naturaleza del Producto
      </h4>
      <p data-id="element-93">
        "Menopausia Sin Niebla" es un producto digital educativo e informativo.
        El contenido proporcionado tiene fines exclusivamente educativos y no
        constituye consejo médico, diagnóstico ni tratamiento. Siempre consulte
        con un profesional de la salud calificado antes de realizar cambios en
        su dieta, estilo de vida o régimen de salud.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-94">
        3. Entrega del Producto
      </h4>
      <p data-id="element-95">
        Tras completar la compra, recibirá acceso inmediato al contenido
        digital. Dado que se trata de un producto digital con entrega
        instantánea, todas las ventas son finales.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-96">
        4. Propiedad Intelectual
      </h4>
      <p data-id="element-97">
        Todo el contenido incluido en este producto — textos, gráficos, guías,
        planes y materiales — es propiedad exclusiva de Menopausia Sin Niebla y
        está protegido por las leyes de propiedad intelectual. Queda prohibida
        la reproducción, distribución o reventa del contenido sin autorización
        expresa por escrito.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-98">
        5. Limitación de Responsabilidad
      </h4>
      <p data-id="element-99">
        Los resultados pueden variar de persona a persona. No garantizamos
        resultados específicos. En ningún caso seremos responsables por daños
        directos, indirectos, incidentales o consecuentes que resulten del uso o
        la incapacidad de usar nuestro producto.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-100">
        6. Descargo de Responsabilidad Médica
      </h4>
      <p data-id="element-101">
        Este producto no pretende diagnosticar, tratar, curar ni prevenir
        ninguna enfermedad. La información proporcionada no sustituye la
        relación con su médico u otro profesional de la salud. Si está
        embarazada, en período de lactancia, tomando medicamentos o tiene una
        condición médica, consulte a su médico antes de usar este producto.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-102">7. Modificaciones</h4>
      <p data-id="element-103">
        Nos reservamos el derecho de modificar estos términos y condiciones en
        cualquier momento. Las modificaciones entrarán en vigor inmediatamente
        después de su publicación en el sitio web.
      </p>

      <h4 className="text-lg font-semibold text-teal-900" data-id="element-104">8. Ley Aplicable</h4>
      <p data-id="element-105">
        Estos términos se regirán e interpretarán de acuerdo con las leyes
        aplicables, sin dar efecto a ningún principio de conflicto de leyes.
      </p>
    </>;
}